import React                      from 'react';

import { AddPhotoVector         } from 'src/components/vector/add-photo';

import { Container,
         PhotoArea,
         Label,
         LabelsStack,
         AllowCount,
         AttachmentAddVariants,
         attachmentadd_variants } from 'src/components/features/inspection/edit/attachment-add/ui';

import * as types                 from 'src/services/api/types';



type Props = {
  variant: AttachmentAddVariants;
  attachmentType: types.inspection.PieceFileType;
  label: string;
  allowCount?: number;
  isRequired?: boolean;
  onTap: (attachmentType: types.inspection.PieceFileType) => void;
  onDragFiles: (files: FileList) => void;
}
export const AttachmentAdd: React.FC<Props> = ({
  variant, attachmentType, allowCount, label, isRequired = false, onTap, onDragFiles
}) => {
  const lookAndFeel = attachmentadd_variants.get(variant)!;

  const [phase, setPhase] = React.useState<"idle" | "drag" | "progress">("idle");

  let icon = <AddPhotoVector />;

  const eventDragBreak = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const dragOverHandler = (event: React.DragEvent<HTMLDivElement>) => {
    eventDragBreak(event);
    setPhase("drag");
  };

  const dropHandler = (event: React.DragEvent<HTMLDivElement>) => {
    eventDragBreak(event);

    const { files } = event.dataTransfer;

    if (files.length > 0) 
    {
      onDragFiles(files);
    }
    return setPhase("idle");
  };

  const dragLeaveHandler = (event: React.DragEvent<HTMLDivElement>) => {
    eventDragBreak(event);
    setPhase("idle");
  };

  return (
    <Container lookAndFeel = { lookAndFeel }>
      <PhotoArea
        lookAndFeel = { lookAndFeel }
        onClick = { () => onTap(attachmentType) }
        onDrop={dropHandler}
        onDragOver={dragOverHandler}
        onDragEnter={dragOverHandler}
        onDragLeave={dragLeaveHandler}
      >
        { icon }
      </PhotoArea>
      <LabelsStack lookAndFeel = { lookAndFeel }>
        <Label lookAndFeel = { lookAndFeel }>
          { label }
          { isRequired && <i>*</i> }
        </Label>
        {allowCount && (
          <AllowCount lookAndFeel = { lookAndFeel }>
            { `Осталось: ${allowCount} шт.` }
          </AllowCount>
        )}
      </LabelsStack>
    </Container>
  );
}
